import {Injectable} from '@angular/core';

@Injectable()
export class PermissionConstant {
  static ALL = 'ALL';

  static DASHBOARD: string = 'DASHBOARDS';
  static HOME: string = 'DASHBOARDS_HOME';

  static ACADEMIC: string = 'ACADEMIC';
  static ACADEMIC_SCHOOL: string = 'ACADEMIC_SCHOOL';
  static ACADEMIC_DEPARTMENT: string = 'ACADEMIC_DEPARTMENT';

  static GENERAL: string = 'GENERALS';

  static ADMIN: string = 'GENERALS_ADMINS';
  static ADMIN_ADD: string = 'GENERALS_ADMINS_ADD';
  static ADMIN_LIST: string = 'GENERALS_ADMINS_LIST';
  static ADMIN_UPDATE: string = 'GENERALS_ADMINS_LIST_UPDATE';
  static ADMIN_PASSWORD: string = 'GENERALS_ADMINS_LIST_PASSWORD';
  static ADMIN_PROFILE_IMAGE: string = 'GENERALS_ADMINS_LIST_PROFILE_IMAGE';
  static ADMIN_STATUS: string = 'GENERALS_ADMINS_LIST_STATUS';
  static ADMIN_DELETE: string = 'GENERALS_ADMINS_LIST_DELETE';

  static CENTER: string = 'GENERALS_CENTERS';
  static CENTER_ADD: string = 'GENERALS_CENTERS_ADD';
  static CENTER_LIST: string = 'GENERALS_CENTERS_LIST';
  static CENTER_SHARING_PERCENTAGE: string = 'GENERALS_CENTERS_LIST_SHARING_PERCENTAGE';
  static CENTER_SHARING_PERCENTAGE_ADD: string = 'GENERALS_CENTERS_LIST_SHARING_PERCENTAGE_ADD';
  static CENTER_SHARING_PERCENTAGE_REMOVE: string = 'GENERALS_CENTERS_LIST_SHARING_PERCENTAGE_REMOVE';
  static CENTER_SHARING_PERCENTAGE_ADD_ALL: string = 'GENERALS_CENTERS_LIST_SHARING_PERCENTAGE_ADD_ALL';
  static CENTER_SHARING_PERCENTAGE_REMOVE_ALL: string = 'GENERALS_CENTERS_LIST_SHARING_PERCENTAGE_REMOVE_ALL';
  static CENTER_UPDATE: string = 'GENERALS_CENTERS_LIST_UPDATE';
  static CENTER_PASSWORD: string = 'GENERALS_CENTERS_LIST_PASSWORD';
  static CENTER_PROFILE_IMAGE: string = 'GENERALS_CENTERS_LIST_PROFILE_IMAGE';
  static CENTER_STATUS: string = 'GENERALS_CENTERS_LIST_STATUS';
  static CENTER_MFA: string = 'GENERALS_CENTERS_LIST_MFA';
  static CENTER_MFA_RESET: string = 'GENERALS_CENTERS_LIST_MFA_RESET';
  static CENTER_DELETE: string = 'GENERALS_CENTERS_LIST_DELETE';
  static CENTER_WALLET_RECHARGE: string = 'GENERALS_CENTERS_LIST_WALLET_RECHARGE';

  static SESSION: string = 'GENERALS_SESSIONS';
  static SESSION_ADD: string = 'GENERALS_SESSIONS_ADD';
  static SESSION_LIST: string = 'GENERALS_SESSIONS_LIST';
  static SESSION_LIST_SIGNATURE: string = 'GENERALS_SESSIONS_LIST_SIGNATURE';
  static SESSION_ADMISSION_STATUS: string = 'GENERALS_SESSIONS_LIST_ADMISSION_STATUS';
  static SESSION_DEFAULT: string = 'GENERALS_SESSIONS_LIST_DEFAULT';
  static SESSION_UPDATE: string = 'GENERALS_SESSIONS_LIST_UPDATE';
  static SESSION_STATUS: string = 'GENERALS_SESSIONS_LIST_STATUS';
  static SESSION_DELETE: string = 'GENERALS_SESSIONS_LIST_DELETE';

  static MEETINGS: string = 'GENERALS_MEETINGS';

  static MEETING_PERSON: string = 'GENERALS_MEETINGS_PERSONS';
  static MEETING_PERSON_ADD: string = 'GENERALS_MEETINGS_PERSONS_ADD';
  static MEETING_PERSON_UPDATE: string = 'GENERALS_MEETINGS_PERSONS_UPDATE';
  static MEETING_PERSON_STATUS: string = 'GENERALS_MEETINGS_PERSONS_STATUS';
  static PERSON_DELETE: string = 'GENERALS_MEETINGS_PERSONS_DELETE';

  static MEETING_SCHEDULE: string = 'GENERALS_MEETINGS_SCHEDULE';
  static MEETING_SCHEDULE_ADD: string = 'GENERALS_MEETINGS_SCHEDULE_ADD';
  static MEETINGS_SCHEDULE_DETAIL: string = 'GENERALS_MEETINGS_SCHEDULE_DETAIL';
  static MEETING_SCHEDULE_VISITOR_TOKEN: string = 'GENERALS_MEETINGS_SCHEDULE_VISITOR_TOKEN';
  static MEETING_SCHEDULE_UPDATE: string = 'GENERALS_MEETINGS_SCHEDULE_UPDATE';
  static MEETING_SCHEDULE_DELETE: string = 'GENERALS_MEETINGS_SCHEDULE_DELETE';

  static GENERAL_REPORT: string = 'GENERALS_REPORTS';

  static EMPLOYEE: string = 'EMPLOYEES';

  static DEPARTMENT: string = 'EMPLOYEES_DEPARTMENTS';
  static DEPARTMENT_ADD: string = 'EMPLOYEES_DEPARTMENTS_ADD';
  static DEPARTMENT_ACADEMIC_LEADERSHIP: string = 'EMPLOYEES_DEPARTMENTS_ACADEMIC_LEADERSHIP';
  static DEPARTMENT_UPDATE: string = 'EMPLOYEES_DEPARTMENTS_UPDATE';
  static DEPARTMENT_STATUS: string = 'EMPLOYEES_DEPARTMENTS_STATUS';
  static DEPARTMENT_DELETE: string = 'EMPLOYEES_DEPARTMENTS_DELETE';

  static DESIGNATION: string = 'EMPLOYEES_DESIGNATIONS';
  static DESIGNATION_ADD: string = 'EMPLOYEES_DESIGNATIONS_ADD';
  static DESIGNATION_UPDATE: string = 'EMPLOYEES_DESIGNATIONS_UPDATE';
  static DESIGNATION_STATUS: string = 'EMPLOYEES_DESIGNATIONS_STATUS';
  static DESIGNATION_DELETE: string = 'EMPLOYEES_DESIGNATIONS_DELETE';
  static DESIGNATION_PERMISSION: string = 'EMPLOYEES_DESIGNATIONS_PERMISSION';
  static DESIGNATION_PERMISSION_UPDATE: string = 'EMPLOYEES_DESIGNATIONS_PERMISSION_UPDATE';

  static EMPLOYEE_ADD: string = 'EMPLOYEES_ADD';
  static EMPLOYEE_UPDATE: string = 'EMPLOYEES_LIST_UPDATE';

  static EMPLOYEE_LIST: string = 'EMPLOYEES_LIST';
  static EMPLOYEE_EDIT: string = 'EMPLOYEES_LIST_EDIT';
  static EMPLOYEE_PASSWORD: string = 'EMPLOYEES_LIST_PASSWORD';
  static EMPLOYEE_SUBJECT: string = 'EMPLOYEES_LIST_SUBJECT';
  static EMPLOYEE_SUBJECT_ADD: string = 'EMPLOYEES_LIST_SUBJECT_ADD';
  static EMPLOYEE_SUBJECT_UPDATE: string = 'EMPLOYEES_LIST_SUBJECT_UPDATE';
  static EMPLOYEE_SUBJECT_STATUS: string = 'EMPLOYEES_LIST_SUBJECT_STATUS';
  static EMPLOYEE_SUBJECT_DELETE: string = 'EMPLOYEES_LIST_SUBJECT_DELETE';
  static EMPLOYEE_SUPERVISOR: string = 'EMPLOYEES_LIST_SUPERVISOR';
  static EMPLOYEE_SALARY: string = 'EMPLOYEES_LIST_SALARY';
  static EMPLOYEE_EVALUATION: string = 'EMPLOYEES_LIST_EVALUATION';
  static EMPLOYEE_EVALUATION_ADD: string = 'EMPLOYEES_LIST_EVALUATION_ADD';
  static EMPLOYEE_EVALUATION_UPDATE: string = 'EMPLOYEES_LIST_EVALUATION_UPDATE';
  static EMPLOYEE_ASSIGN_VEHICLE: string = 'EMPLOYEES_LIST_ASSIGN_VEHICLE';
  static EMPLOYEE_DOWNLOAD_LEAVE: string = 'EMPLOYEES_LIST_DOWNLOAD_LEAVE';
  static EMPLOYEE_UPCOMING_CLASSES: string = 'EMPLOYEES_UPCOMING_CLASSES';
  static EMPLOYEE_PREVIOUS_CLASSES: string = 'EMPLOYEES_PREVIOUS_CLASSES';
  static EMPLOYEE_EVALUATOR: string = 'EMPLOYEES_EVALUATOR';
  static EMPLOYEE_STATUS: string = 'EMPLOYEES_LIST_STATUS';
  static EMPLOYEE_DELETE: string = 'EMPLOYEES_LIST_DELETE';

  static EMPLOYEE_ATTENDANCE: string = 'EMPLOYEES_ATTENDANCE';
  static EMPLOYEE_UPLOAD_ATTENDANCE: string = 'EMPLOYEES_UPLOAD_ATTENDANCE';
  static EMPLOYEE_ATTENDANCE_MARK: string = 'EMPLOYEES_ATTENDANCE_MARK';

  static EMPLOYEES_LEAVE: string = 'EMPLOYEES_LEAVE';
  static EMPLOYEES_LEAVE_DETAIL: string = 'EMPLOYEES_LEAVE_DETAIL';
  static EMPLOYEES_LEAVE_UPDATE: string = 'EMPLOYEES_LEAVE_UPDATE';
  static EMPLOYEES_LEAVE_STATUS: string = 'EMPLOYEES_LEAVE_STATUS';
  static EMPLOYEES_LEAVE_DELETE: string = 'EMPLOYEES_LEAVE_DELETE';

  static RESIGNATION: string = 'EMPLOYEES_RESIGNATION';
  static RESIGNATION_DETAIL: string = 'EMPLOYEES_RESIGNATION_DETAIL';
  static RESIGNATION_DOCUMENT: string = 'EMPLOYEES_RESIGNATION_DOCUMENT';
  static EMPLOYEE_RESIGNATION = 'EMPLOYEES_RESIGNATION_EMPLOYEES';

  static EMPLOYEE_PAYROLL: string = 'EMPLOYEES_PAYROLL';
  static EMPLOYEE_PAYROLL_ADD: string = 'EMPLOYEES_PAYROLL_ADD';
  static EMPLOYEE_PAYROLL_HR_STATUS: string = 'EMPLOYEES_PAYROLL_HR_STATUS';
  static EMPLOYEE_PAYROLL_ACCOUNT_STATUS: string = 'EMPLOYEES_PAYROLL_ACCOUNT_STATUS';

  static PERMISSION: string = 'EMPLOYEES_PERMISSIONS';
  static PERMISSION_ADD: string = 'EMPLOYEES_PERMISSIONS_ADD';
  static PERMISSION_UPDATE: string = 'EMPLOYEES_PERMISSIONS_UPDATE';
  static PERMISSION_STATUS: string = 'EMPLOYEES_PERMISSIONS_STATUS';
  static PERMISSION_SUB_PERMISSION: string = 'EMPLOYEES_PERMISSIONS_SUB_PERMISSION';
  static PERMISSION_SUB_PERMISSION_ADD: string = 'EMPLOYEES_PERMISSIONS_SUB_PERMISSION_ADD';
  static PERMISSION_SUB_PERMISSION_UPDATE: string = 'EMPLOYEES_PERMISSIONS_SUB_PERMISSION_UPDATE';
  static PERMISSION_SUB_PERMISSION_STATUS: string = 'EMPLOYEES_PERMISSIONS_SUB_PERMISSION_STATUS';
  static PERMISSION_SUB_PERMISSION_DELETE: string = 'EMPLOYEES_PERMISSIONS_SUB_PERMISSION_DELETE';
  static PERMISSION_DELETE: string = 'EMPLOYEES_PERMISSIONS_DELETE';

  static EMPLOYEE_REPORT: string = 'EMPLOYEES_REPORTS';

  static MODULE: string = 'MODULES';

  static SCHOOL: string = 'MODULES_SCHOOLS';
  static SCHOOL_ADD: string = 'MODULES_SCHOOLS_ADD';
  static SCHOOL_UPDATE: string = 'MODULES_SCHOOLS_UPDATE';
  static SCHOOL_STATUS: string = 'MODULES_SCHOOLS_STATUS';
  static SCHOOL_DELETE: string = 'MODULES_SCHOOLS_DELETE';

  static PROGRAM: string = 'MODULES_PROGRAMS';
  static PROGRAM_ADD: string = 'MODULES_PROGRAMS_ADD';
  static PROGRAM_UPDATE: string = 'MODULES_PROGRAMS_UPDATE';
  static PROGRAM_STATUS: string = 'MODULES_PROGRAMS_STATUS';
  static PROGRAM_DELETE: string = 'MODULES_PROGRAMS_DELETE';

  static COURSE: string = 'MODULES_COURSES';
  static COURSE_ADD: string = 'MODULES_COURSES_ADD';
  static COURSE_UPDATE: string = 'MODULES_COURSES_UPDATE';
  static COURSE_STATUS: string = 'MODULES_COURSES_STATUS';
  static COURSE_DELETE: string = 'MODULES_COURSES_DELETE';

  static BRANCH: string = 'MODULES_BRANCHES';
  static BRANCH_ADD: string = 'MODULES_BRANCHES_ADD';
  static BRANCH_UPDATE: string = 'MODULES_BRANCHES_UPDATE';
  static BRANCH_STATUS: string = 'MODULES_BRANCHES_STATUS';
  static BRANCH_DELETE: string = 'MODULES_BRANCHES_DELETE';

  static MAPPING: string = 'MODULES_MAPPINGS';
  static MAPPING_ADD: string = 'MODULES_MAPPINGS_ADD';
  static MAPPING_FEE_STRUCTURE: string = 'MODULES_MAPPINGS_FEE_STRUCTURE';
  static MAPPING_HOD: string = 'MODULES_MAPPINGS_HOD';
  static MAPPING_DEPARTMENT: string = 'MODULES_MAPPINGS_DEPARTMENT';
  static MAPPING_SUBJECT: string = 'MODULES_MAPPINGS_SUBJECT';
  static MAPPING_SECTION: string = 'MODULES_MAPPINGS_SECTION';
  static MAPPING_SECTION_ADD: string = 'MODULES_MAPPINGS_SECTION_ADD';
  static MAPPING_SECTION_UPDATE: string = 'MODULES_MAPPINGS_SECTION_UPDATE';
  static MAPPING_SECTION_STATUS: string = 'MODULES_MAPPINGS_SECTION_STATUS';
  static MAPPING_SECTION_DELETE: string = 'MODULES_MAPPINGS_SECTION_DELETE';
  static MAPPING_TIMETABLE: string = 'MODULES_MAPPINGS_TIMETABLE';
  static MAPPING_TIMETABLE_ADD: string = 'MODULES_MAPPINGS_TIMETABLE_ADD';
  static MAPPING_SESSION: string = 'MODULES_MAPPINGS_SESSION';
  static MAPPING_UPDATE: string = 'MODULES_MAPPINGS_UPDATE';
  static MAPPING_STATUS: string = 'MODULES_MAPPINGS_STATUS';
  static MAPPING_DELETE: string = 'MODULES_MAPPINGS_DELETE';

  static SUBJECT: string = 'MODULES_SUBJECTS';
  static SUBJECT_ADD: string = 'MODULES_SUBJECTS_ADD';
  static SUBJECT_SLM: string = 'MODULES_SUBJECTS_SLM';
  static SUBJECT_NOTE: string = 'MODULES_SUBJECTS_NOTE';
  static SUBJECT_UPDATE: string = 'MODULES_SUBJECTS_UPDATE';
  static SUBJECT_STATUS: string = 'MODULES_SUBJECTS_STATUS';
  static SUBJECT_CHAPTER: string = 'MODULES_SUBJECTS_CHAPTER';
  static SUBJECT_DELETE: string = 'MODULES_SUBJECTS_DELETE';

  static MODULE_REPORT: string = 'MODULES_REPORTS';

  static INVENTORY: string = 'INVENTORIES';

  static INVENTORY_CATEGORY: string = 'INVENTORIES_CATEGORIES';
  static INVENTORY_CATEGORY_ADD: string = 'INVENTORIES_CATEGORIES_ADD';
  static INVENTORY_CATEGORY_UPDATE: string = 'INVENTORIES_CATEGORIES_UPDATE';
  static INVENTORY_CATEGORY_STATUS: string = 'INVENTORIES_CATEGORIES_STATUS';
  static INVENTORY_CATEGORY_DELETE: string = 'INVENTORIES_CATEGORIES_DELETE';

  static INVENTORY_STORE: string = 'INVENTORIES_STORE';
  static INVENTORY_STORE_ADD: string = 'INVENTORIES_STORE_ADD';
  static INVENTORY_STORE_UPDATE: string = 'INVENTORIES_STORE_UPDATE';
  static INVENTORY_STORE_STATUS: string = 'INVENTORIES_STORE_STATUS';
  static INVENTORY_STORE_DELETE: string = 'INVENTORIES_STORE_DELETE';

  static INVENTORY_DEPARTMENT: string = 'INVENTORY_DEPARTMENT';
  static INVENTORY_DEPARTMENT_ADD: string = 'INVENTORY_DEPARTMENT_ADD';
  static INVENTORY_DEPARTMENT_HOD: string = 'INVENTORY_DEPARTMENT_HOD';
  static INVENTORY_DEPARTMENT_UPDATE: string = 'INVENTORY_DEPARTMENT_UPDATE';
  static INVENTORY_DEPARTMENT_STATUS: string = 'INVENTORY_DEPARTMENT_STATUS';
  static INVENTORY_DEPARTMENT_DELETE: string = 'INVENTORY_DEPARTMENT_DELETE';

  static INVENTORY_DEMAND: string = 'INVENTORY_DEMAND';
  static INVENTORY_DEMAND_STATUS: string = 'INVENTORY_DEMAND_STATUS';

  static INVENTORY_ALLOCATION: string = 'INVENTORY_ALLOCATION';
  static INVENTORY_ALLOCATION_ADD: string = 'INVENTORY_ALLOCATION_ADD';
  static INVENTORY_ALLOCATION_UPDATE: string = 'INVENTORY_ALLOCATION_UPDATE';
  static INVENTORY_ALLOCATION_DISPATCH: string = 'INVENTORY_ALLOCATION_DISPATCH';
  static INVENTORY_ALLOCATION_STATUS: string = 'INVENTORY_ALLOCATION_STATUS';
  static INVENTORY_ALLOCATION_DELETE: string = 'INVENTORY_ALLOCATION_DELETE';

  static INVENTORY_LIST: string = 'INVENTORIES_LIST';
  static INVENTORY_LIST_ADD: string = 'INVENTORIES_LIST_ADD';
  static INVENTORY_LIST_UPDATE: string = 'INVENTORIES_LIST_UPDATE';
  static INVENTORY_LIST_STOCK: string = 'INVENTORIES_LIST_STOCK';
  static INVENTORY_STOCK_ADD: string = 'INVENTORY_STOCK_ADD';
  static INVENTORY_STOCK_INVOICE: string = 'INVENTORY_STOCK_INVOICE';
  static INVENTORY_STOCK_UPDATE: string = 'INVENTORY_STOCK_UPDATE';
  static INVENTORY_STOCK_STATUS: string = 'INVENTORY_STOCK_STATUS';
  static INVENTORY_STOCK_DELETE: string = 'INVENTORY_STOCK_DELETE';
  static INVENTORY_LIST_STATUS: string = 'INVENTORIES_LIST_STATUS';
  static INVENTORY_LIST_DELETE: string = 'INVENTORIES_LIST_DELETE';

  static INVENTORY_TRANSACTION: string = 'INVENTORIES_TRANSACTIONS';
  static INVENTORY_TRANSACTION_STATUS: string = 'INVENTORIES_TRANSACTIONS_STATUS';

  static INVENTORY_REPORT: string = 'INVENTORIES_REPORTS';

  static BOOK: string = 'BOOKS';
  static BOOK_SEARCH: string = 'BOOKS_SEARCH';

  static BOOK_CATEGORY: string = 'BOOKS_CATEGORIES';
  static BOOK_CATEGORY_ADD: string = 'BOOKS_CATEGORIES_ADD';
  static BOOK_CATEGORY_UPDATE: string = 'BOOKS_CATEGORIES_UPDATE';
  static BOOK_CATEGORY_STATUS: string = 'BOOKS_CATEGORIES_STATUS';
  static BOOK_CATEGORY_DELETE: string = 'BOOKS_CATEGORIES_DELETE';

  static BOOK_LIST: string = 'BOOKS_LIST';
  static BOOK_ADD: string = 'BOOKS_LIST_ADD';
  static BOOK_ISBN: string = 'BOOKS_LIST_ISBN';
  static BOOK_COVER: string = 'BOOKS_LIST_BOOK_COVER';
  static BOOK_UPDATE: string = 'BOOKS_LIST_UPDATE';
  static BOOK_STOCK: string = 'BOOKS_LIST_STOCK';
  static BOOK_STOCK_ADD: string = 'BOOKS_STOCK_ADD';
  static BOOK_STOCK_INVOICE_FILE: string = 'BOOKS_STOCK_INVOICE_FILE';
  static BOOK_STOCK_UPDATE: string = 'BOOKS_STOCK_UPDATE';
  static BOOK_STOCK_STATUS: string = 'BOOKS_STOCK_STATUS';
  static BOOK_STOCK_DELETE: string = 'BOOKS_STOCK_DELETE';
  static BOOK_STATUS: string = 'BOOKS_LIST_STATUS';
  static BOOK_DELETE: string = 'BOOKS_LIST_DELETE';
  static BOOK_OPEN: string = 'BOOKS_LIST_OPEN';

  static BOOKS_SUPPLIERS: string = 'BOOKS_SUPPLIERS';
  static BOOKS_SUPPLIERS_ADD: string = 'BOOKS_SUPPLIERS_ADD';
  static BOOKS_SUPPLIERS_UPDATE: string = 'BOOKS_SUPPLIERS_UPDATE';
  static BOOKS_SUPPLIERS_STATUS: string = 'BOOKS_SUPPLIERS_STATUS';
  static BOOKS_SUPPLIERS_DELETE: string = 'BOOKS_SUPPLIERS_DELETE';

  static BOOK_TRANSACTION: string = 'BOOKS_TRANSACTIONS';
  static BOOK_TRANSACTION_STATUS: string = 'BOOKS_TRANSACTIONS_STATUS';
  static BOOK_TRANSACTION_DELETE: string = 'BOOKS_TRANSACTIONS_DELETE';

  static BOOKS_SETTINGS: string = 'BOOKS_SETTINGS';
  static BOOK_REPORT: string = 'BOOKS_REPORTS';

  static LIBRARY: string = 'LIBRARIES';

  static LIBRARIES_LIST: string = 'LIBRARIES_LIST';
  static LIBRARIES_LIST_ADD: string = 'LIBRARIES_LIST_ADD';
  static LIBRARIES_LIST_ADD_BOOK: string = 'LIBRARIES_LIST_ADD_BOOK';
  static LIBRARIES_LIST_UPDATE: string = 'LIBRARIES_LIST_UPDATE';
  static LIBRARIES_LIST_STATUS: string = 'LIBRARIES_LIST_STATUS';
  static LIBRARIES_LIST_DELETE: string = 'LIBRARIES_LIST_DELETE';

  static LIBRARY_BORROWING: string = 'LIBRARIES_BORROWINGS';
  static LIBRARY_BORROWING_ADD: string = 'LIBRARIES_BORROWINGS_ADD';
  static LIBRARY_BORROWING_RETURN: string = 'LIBRARIES_BORROWINGS_RETURN';
  static LIBRARY_BORROWING_STATUS: string = 'LIBRARIES_BORROWINGS_STATUS';
  static LIBRARY_BORROWING_DELETE: string = 'LIBRARIES_BORROWINGS_DELETE';

  static LIBRARY_TRANSACTION: string = 'LIBRARIES_TRANSACTIONS';
  static LIBRARY_TRANSACTION_STATUS: string = 'LIBRARIES_TRANSACTIONS_STATUS';

  static LIBRARY_REPORT: string = 'LIBRARIES_REPORTS';
  static LIBRARY_REPORT_DOWNLOAD: string = 'LIBRARIES_REPORTS_DOWNLOAD';

  static ASSIGNMENT_LIST: string = 'ASSIGNMENT_LIST';

  static LEADS: string = 'LEADS';

  static LEADS_STAGE: string = 'LEADS_STAGE';
  static LEADS_STAGE_ADD: string = 'LEADS_STAGE_ADD';
  static LEADS_STAGE_UPDATE: string = 'LEADS_STAGE_UPDATE';
  static LEADS_STAGE_DELETE: string = 'LEADS_STAGE_DELETE';
  static LEADS_STAGE_LIST: string = 'LEADS_STAGE_LIST';

  static LEADS_LEAD: string = 'LEADS_LEAD';
  static LEADS_LEAD_LIST: string = 'LEADS_LEAD_LIST';
  static LEADS_LEAD_UPDATE: string = 'LEADS_LEAD_UPDATE';
  static LEADS_LEAD_STATUS: string = 'LEADS_LEAD_STATUS';
  static LEADS_LEAD_DELETE: string = 'LEADS_LEAD_DELETE';

  static LEADS_FOLLOW_UPS: string = 'LEADS_FOLLOW_UPS';
  static LEADS_FOLLOW_UPS_ADD: string = 'LEADS_FOLLOW_UPS_ADD';
  static LEADS_FOLLOW_UPS_UPDATE: string = 'LEADS_FOLLOW_UPS_UPDATE';
  static LEADS_FOLLOW_UPS_DELETE: string = 'LEADS_FOLLOW_UPS_DELETE';

  static LEADS_WEBSITE_LEAD: string = 'LEADS_WEBSITE_LEAD';
  static LEADS_WEBSITE_LEAD_ADD_STUDENT: string = 'LEADS_WEBSITE_LEAD_ADD_STUDENT';
  static LEADS_WEBSITE_LEAD_FOLLOW_UPS: string = 'LEADS_WEBSITE_LEAD_FOLLOW_UPS';

  static STUDENT: string = 'STUDENTS';
  static STUDENT_ADD: string = 'STUDENTS_ADD';
  static STUDENT_SEARCH: string = 'STUDENT_SEARCH';

  static STUDENT_LIST: string = 'STUDENTS_DIRECT_STUDENTS';
  static STUDENT_PROFILE: string = 'STUDENTS_DIRECT_STUDENTS_PROFILE';
  static STUDENT_ADMISSION_NO: string = 'STUDENTS_DIRECT_STUDENTS_ADMISSION_NO';
  static STUDENT_EXCEL: string = 'STUDENTS_DIRECT_STUDENTS_EXCEL';
  static STUDENT_DIRECT_EDIT: string = 'STUDENTS_DIRECT_STUDENTS_EDIT';
  static STUDENT_DIRECT_ADMISSION_DATE: string = 'STUDENTS_DIRECT_ADMISSION_DATE';
  static STUDENT_DIRECT_ASSIGN_HOSTEL: string = 'STUDENTS_DIRECT_ASSIGN_HOSTEL';
  static STUDENT_DIRECT_ASSIGN_VEHICLE: string = 'STUDENTS_DIRECT_ASSIGN_VEHICLE';
  static STUDENT_DIRECT_ASSIGN_SECTION: string = 'STUDENTS_DIRECT_ASSIGN_SECTION';
  static STUDENT_DIRECT_PRINT: string = 'STUDENTS_DIRECT_PRINT';
  static STUDENT_DIRECT_ID_CARD: string = 'STUDENTS_DIRECT_ID_CARD';
  static STUDENT_DIRECT_FEE: string = 'STUDENTS_DIRECT_STUDENTS_FEE';
  static STUDENT_DIRECT_DELETE: string = 'STUDENTS_DIRECT_STUDENTS_DELETE';
  static STUDENT_VERIFY: string = 'STUDENTS_VERIFY_DIRECT_STUDENT';
  static STUDENT_DIRECT_VERIFY: string = 'STUDENTS_VERIFY_DIRECT_STUDENT_VERIFY';
  static STUDENT_DIRECT_ADMISSION_NO_DUES: string = 'STUDENTS_DIRECT_ADMISSION_NO_DUES';
  static STUDENT_DIRECT_ACCOUNT_NO_DUES: string = 'STUDENTS_DIRECT_ACCOUNT_NO_DUES';
  static STUDENT_DIRECT_EXAMINATION_NO_DUES: string = 'STUDENTS_DIRECT_EXAMINATION_NO_DUES';

  static STUDENT_CENTER: string = 'STUDENTS_CENTER_STUDENT';
  static STUDENT_CENTER_PROFILE: string = 'STUDENTS_CENTER_STUDENT_PROFILE';
  static STUDENT_CENTER_EXCEL: string = 'STUDENTS_CENTER_STUDENT_EXCEL';
  static STUDENT_CENTER_FEE: string = 'STUDENTS_CENTER_STUDENT_FEE';
  static STUDENT_VERIFY_CENTER: string = 'STUDENTS_VERIFY_CENTER_STUDENT';
  static STUDENT_VERIFY_CENTER_VERIFY: string = 'STUDENTS_VERIFY_CENTER_STUDENT_VERIFY';

  static STUDENT_SCHOLARSHIP: string = 'STUDENTS_STUDENTS_VERIFY_SCHOLARSHIP';
  static STUDENT_SCHOLARSHIP_DOCS: string = 'STUDENTS_STUDENTS_VERIFY_SCHOLARSHIP_DOCS';
  static STUDENT_SCHOLARSHIP_PAYMENT: string = 'STUDENT_SCHOLARSHIP_PAYMENT';
  static SCHOLARSHIP_FEE_UPDATE: string = 'STUDENT_SCHOLARSHIP_FEE_UPDATE';
  static SCHOLARSHIP_DOC_UPDATE: string = 'STUDENT_SCHOLARSHIP_DOC_UPDATE';
  static SCHOLARSHIP_STATUS_UPDATE: string = 'STUDENT_SCHOLARSHIP_STATUS_UPDATE';

  static STUDENT_TRANSACTION: string = 'STUDENTS_DIRECT_STUDENTS_TRANSACTION';
  static STUDENT_TRANSACTION_RECEIPT: string = 'STUDENTS_DIRECT_STUDENTS_TRANSACTION_RECEIPT';

  static STUDENT_ATTENDANCE: string = 'STUDENTS_ATTENDANCE';
  static STUDENT_ATTENDANCE_MARK: string = 'STUDENTS_ATTENDANCE_MARK';

  static STUDENT_ENROLLMENT: string = 'STUDENTS_ENROLLMENT';
  static STUDENT_ENROLLMENT_ASSIGN: string = 'STUDENTS_ENROLLMENT_ASSIGN';

  static FINAL_STUDENT_LIST: string = 'STUDENTS_FINAL_STUDENT';
  static FINAL_STUDENT_PROFILE: string = 'STUDENTS_FINAL_STUDENT_PROFILE';
  static FINAL_STUDENT_EXCEL: string = 'STUDENTS_FINAL_STUDENT_EXCEL';
  static FINAL_STUDENT_EDIT: string = 'STUDENTS_FINAL_STUDENT_EDIT';
  static FINAL_STUDENT_FEE: string = 'STUDENTS_FINAL_STUDENT_FEE';

  static STUDENT_FINAL_VERIFICATION: string = 'STUDENTS_FINAL_VERIFICATION';
  static STUDENT_FINAL_VERIFICATION_VERIFY: string = 'STUDENTS_FINAL_VERIFICATION_VERIFY';
  static STUDENT_FINAL_VERIFICATION_DETAIL: string = 'STUDENTS_FINAL_VERIFICATION_DETAIL';

  static STUDENT_PROGRESS_MANAGER: string = 'STUDENTS_PROGRESS_MANAGER';
  static STUDENT_PROGRESS_MANAGER_ASSIGNMENT: string = 'STUDENTS_PROGRESS_MANAGER_ASSIGNMENT';

  static STUDENT_HOSTEL: string = 'STUDENTS_HOSTEL_STUDENT';
  static STUDENT_VEHICLE: string = 'STUDENTS_VEHICLE_STUDENT';

  static FINALISED_STUDENT_LIST = 'STUDENTS_FINALISED_STUDENT_LIST';
  static HOSTEL_STUDENT_LIST = 'STUDENTS_HOSTEL_STUDENT';
  static TRANSPORTATION_STUDENT_LIST = 'STUDENTS_TRANSPORTATION_STUDENT';

  static STUDENT_LEAVE = 'STUDENTS_LEAVE';
  static STUDENT_SUBJECT = 'STUDENTS_SUBJECT';
  static STUDENT_ELECTIVE_SUBJECT = 'STUDENTS_ELECTIVE_SUBJECT';

  static STUDENT_REPORT: string = 'STUDENTS_REPORTS';
  static STUDENTS_ADMISSION_FORM_COURSE_FEE: string = 'STUDENTS_ADMISSION_FORM_COURSE_FEE';

  static BDE: string = 'BDES';
  static BDE_ADD: string = 'BDES_ADD';
  static BDE_LIST: string = 'BDES_LIST';
  static BDE_ALL_LIST: string = 'BDES_ALL_LIST';
  static BDE_EXCEL: string = 'BDES_LIST_EXCEL';
  static BDE_EDIT: string = 'BDES_LIST_EDIT';
  static BDE_FEE: string = 'BDES_LIST_FEE';
  static BDE_RESULT: string = 'BDES_LIST_RESULT';
  static BDE_DOCUMENTS: string = 'BDES_LIST_DOCUMENT';
  static BDE_DELETE: string = 'BDES_LIST_DELETE';
  static BDE_PAY_FEE = 'BDE_PAY_FEE';

  static ACCOUNT_ACCOUNT: string = 'ACCOUNTS';

  static ACCOUNT_RECEIPT: string = 'ACCOUNTS_RECEIPT';
  static ACCOUNT_RECEIPT_STATUS: string = 'ACCOUNTS_RECEIPT_STATUS';
  static ACCOUNT_RECEIPT_DOCUMENT: string = 'ACCOUNTS_RECEIPT_DOCUMENT';
  static ACCOUNT_RECEIPT_DETAIL: string = 'ACCOUNTS_RECEIPT_DETAIL';
  static ACCOUNT_RECEIPT_TRANSACTION: string = 'ACCOUNTS_RECEIPT_TRANSACTION';

  static ACCOUNT_WALLET_TRANSACTION: string = 'ACCOUNTS_WALLET_TRANSACTION';
  static ACCOUNT_LIABILITY_TRANSACTION: string = 'ACCOUNTS_LIABILITY_TRANSACTION';
  static ACCOUNT_FINAL_STUDENT_TRANSACTION: string = 'ACCOUNTS_FINAL_STUDENT_TRANSACTION';

  static ACCOUNT_STUDENT_TRANSACTION: string = 'ACCOUNTS_STUDENT_TRANSACTION';
  static ACCOUNT_STUDENT_TRANSACTION_CANCELLED: string = 'ACCOUNTS_STUDENT_TRANSACTION_CANCELLED';
  static ACCOUNT_STUDENT_TRANSACTION_DELETE: string = 'ACCOUNTS_STUDENT_TRANSACTION_DELETE';

  static ACCOUNT_FEE_LEDGER: string = 'ACCOUNTS_FEE_LEDGER';
  static ACCOUNT_FEE_CALCULATOR: string = 'ACCOUNTS_FEE_CALCULATOR';
  static ACCOUNT_STUDENT_OTHER_FEE: string = 'ACCOUNTS_STUDENT_OTHER_FEE';

  static ACCOUNT_STUDENT_FEE: string = 'ACCOUNTS_STUDENT_FEE';
  static ACCOUNT_STUDENT_FEE_REPORT_DOWNLOAD: string = 'ACCOUNTS_STUDENT_FEE_REPORT_DOWNLOAD';
  static ACCOUNT_STUDENT_FEE_PREVIEW: string = 'ACCOUNTS_STUDENT_FEE_PREVIEW';
  static ACCOUNT_STUDENT_FEE_PAY_FEE: string = 'ACCOUNTS_STUDENT_FEE_PAY_FEE';
  static ACCOUNT_STUDENT_FEE_PAY_FEE_REMARK: string = 'ACCOUNTS_STUDENT_FEE_PAY_FEE_REMARK';
  static ACCOUNT_STUDENT_FEE_PAY_FEE_PAY_NOW: string = 'ACCOUNTS_STUDENT_FEE_PAY_FEE_PAY_NOW';
  static ACCOUNT_STUDENT_FEE_LEDGER: string = 'ACCOUNTS_STUDENT_FEE_LEDGER';
  static ACCOUNT_STUDENT_FEE_TRANSACTION: string = 'ACCOUNTS_STUDENT_FEE_TRANSACTION';
  static ACCOUNT_STUDENT_FEE_OTHER_FEE: string = 'ACCOUNTS_STUDENT_FEE_OTHER_FEE';
  static ACCOUNT_STUDENT_FEE_SCHOLARSHIP: string = 'ACCOUNTS_STUDENT_FEE_SCHOLARSHIP';
  static ACCOUNT_STUDENT_FEE_REPORTING_STATUS: string = 'ACCOUNT_STUDENT_FEE_REPORTING_STATUS';

  static ACCOUNT_REPORT: string = 'ACCOUNTS_REPORTS';

  static EXAMS: string = 'EXAMS';

  static INTERNAL: string = 'EXAMS_INTERNAL';

  static INTERNAL_EXAM_SESSION: string = 'EXAMS_INTERNAL_SESSIONS';
  static INTERNAL_EXAM_SESSION_ADD: string = 'EXAMS_INTERNAL_SESSIONS_ADD';
  static INTERNAL_EXAM_SESSION_UPDATE: string = 'EXAMS_INTERNAL_SESSIONS_UPDATE';
  static INTERNAL_EXAM_SESSION_STATUS: string = 'EXAMS_INTERNAL_SESSIONS_STATUS';
  static INTERNAL_EXAM_SESSION_DELETE: string = 'EXAMS_INTERNAL_SESSIONS_DELETE';

  static INTERNAL_EXAM_QUESTIONS: string = 'EXAMS_INTERNAL_EXAM_QUESTIONS';
  static INTERNAL_EXAM_QUESTION_SECTIONS: string = 'EXAMS_INTERNAL_EXAM_QUESTION_SECTIONS';
  static INTERNAL_EXAM_QUESTION_SECTION_ADD: string = 'EXAMS_INTERNAL_EXAM_QUESTION_SECTION_ADD';
  static INTERNAL_EXAM_QUESTION_SECTION_UPDATE: string = 'EXAMS_INTERNAL_EXAM_QUESTION_SECTION_UPDATE';
  static INTERNAL_EXAM_QUESTION_SECTION_STATUS: string = 'EXAMS_INTERNAL_EXAM_QUESTION_SECTION_STATUS';
  static INTERNAL_EXAM_QUESTION_SECTION_DELETE: string = 'EXAMS_INTERNAL_EXAM_QUESTION_SECTION_DELETE';
  static INTERNAL_EXAM_QUESTIONS_UPLOAD: string = 'EXAMS_INTERNAL_EXAM_QUESTIONS_UPLOAD';
  static INTERNAL_EXAM_QUESTIONS_DELETE: string = 'EXAMS_INTERNAL_EXAM_QUESTIONS_DELETE';

  static INTERNAL_EXAM_SCHEDULER: string = 'EXAMS_INTERNAL_SCHEDULER';
  static INTERNAL_EXAM_SCHEDULER_FINALIZE_QUESTION: string = 'EXAMS_INTERNAL_SCHEDULER_FINALIZE_QUESTION';
  static INTERNAL_EXAM_SCHEDULER_FETCH_STUDENT: string = 'EXAMS_INTERNAL_SCHEDULER_FETCH_STUDENT';
  static INTERNAL_EXAM_SCHEDULER_MANAGE_SCHEDULE: string = 'EXAMS_INTERNAL_SCHEDULER_MANAGE_SCHEDULE';
  static INTERNAL_EXAM_SCHEDULER_MANAGE_EVALUATION: string = 'EXAMS_INTERNAL_SCHEDULER_MANAGE_EVALUATION';
  static INTERNAL_EXAM_SCHEDULER_MANAGE_HALL: string = 'EXAMS_INTERNAL_SCHEDULER_MANAGE_HALL';
  static INTERNAL_EXAM_SCHEDULER_STUDENT_MARKS_LIST_PRINT: string = 'EXAM_INTERNAL_SCHEDULER_STUDENT_MARKS_LIST_PRINT';
  static INTERNAL_EXAM_SCHEDULER_ELIGIBLE_STUDENT: string = 'EXAMS_INTERNAL_SCHEDULER_ELIGIBLE_STUDENT';
  static INTERNAL_EXAM_SCHEDULE_BACK_PAPER_STUDENT: string = 'EXAMS_INTERNAL_SCHEDULER_BACK_PAPER_STUDENT';
  static INTERNAL_EXAM_SCHEDULER_ADD: string = 'EXAMS_INTERNAL_SCHEDULER_ADD';
  static INTERNAL_EXAM_SCHEDULER_FETCH: string = 'EXAMS_INTERNAL_SCHEDULER_FETCH';
  static INTERNAL_EXAM_SCHEDULER_UPDATE: string = 'EXAMS_INTERNAL_SCHEDULER_UPDATE';
  static INTERNAL_EXAM_SCHEDULER_STATUS: string = 'EXAMS_INTERNAL_SCHEDULER_STATUS';
  static INTERNAL_EXAM_SCHEDULER_DELETE: string = 'EXAMS_INTERNAL_SCHEDULER_DELETE';

  static INTERNAL_EXAM_EVALUATOR: string = 'INTERNAL_EXAM_EVALUATOR';
  static INTERNAL_EXAM_EVALUATOR_ADD: string = 'INTERNAL_EXAM_EVALUATOR_ADD';
  static INTERNAL_EXAM_EVALUATOR_UPDATE: string = 'INTERNAL_EXAM_EVALUATOR_UPDATE';
  static INTERNAL_EXAM_EVALUATOR_DELETE: string = 'INTERNAL_EXAM_EVALUATOR_DELETE';

  static INTERNAL_EXAM_EVALUATOR_SUBJECT: string = 'INTERNAL_EXAM_EVALUATOR_SUBJECT';
  static INTERNAL_EXAM_EVALUATOR_SUBJECT_ADD: string = 'INTERNAL_EXAM_EVALUATOR_SUBJECT_ADD';
  static INTERNAL_EXAM_EVALUATOR_SUBJECT_UPDATE: string = 'INTERNAL_EXAM_EVALUATOR_SUBJECT_UPDATE';
  static INTERNAL_EXAM_EVALUATOR_SUBJECT_DELETE: string = 'INTERNAL_EXAM_EVALUATOR_SUBJECT_DELETE';
  static INTERNAL_EXAM_EVALUATOR_SUBJECT_PERMISSION: string = 'INTERNAL_EXAM_EVALUATOR_SUBJECT_PERMISSION';

  static INTERNAL_EXAM_EVALUATION: string = 'INTERNAL_EXAM_EVALUATION';
  static INTERNAL_EXAM_EVALUATION_STUDENT_MARKS: string = 'INTERNAL_EXAM_EVALUATION_STUDENT_MARKS';

  static INTERNAL_EXAM_EVALUATOR_CHARGE: string = 'INTERNAL_EXAM_EVALUATOR_CHARGE';
  static INTERNAL_EXAM_EVALUATOR_SCHEDULE_EXAM: string = 'INTERNAL_EXAM_EVALUATOR_SCHEDULE_EXAM';

  static INTERNAL_EXAM_ATTENDANCE_DEBAR: string = 'INTERNAL_EXAM_ATTENDANCE_DEBAR';
  static INTERNAL_EXAM_ATTENDANCE_DEBAR_STUDENTS: string = 'INTERNAL_EXAM_ATTENDANCE_DEBAR_STUDENTS';

  static FINAL_EXAM_ATTENDANCE_DEBAR: string = 'FINAL_EXAM_ATTENDANCE_DEBAR';
  static FINAL_EXAM_ATTENDANCE_DEBAR_STUDENTS: string = 'FINAL_EXAM_ATTENDANCE_DEBAR_STUDENTS';

  static INTERNAL_EXAM_HALLS: string = 'EXAMS_INTERNAL_HALLS';
  static INTERNAL_EXAM_HALLS_ADD: string = 'EXAMS_INTERNAL_HALLS_ADD';
  static INTERNAL_EXAM_HALLS_UPDATE: string = 'EXAMS_INTERNAL_HALLS_UPDATE';
  static INTERNAL_EXAM_HALLS_STATUS: string = 'EXAMS_INTERNAL_HALLS_STATUS';
  static INTERNAL_EXAM_HALLS_STUDENT: string = 'EXAMS_INTERNAL_HALLS_STUDENT';
  static INTERNAL_EXAM_HALLS_INVIGILATOR: string = 'EXAMS_INTERNAL_HALLS_INVIGILATOR';
  static INTERNAL_EXAM_HALLS_DELETE: string = 'EXAMS_INTERNAL_HALLS_DELETE';

  static INTERNAL_EXAM_MARK: string = 'EXAMS_INTERNAL_MARK';
  static INTERNAL_EXAM_MARK_STUDENT: string = 'EXAMS_INTERNAL_MARK_STUDENT';
  static INTERNAL_EXAM_STUDENT_MARK: string = 'EXAMS_INTERNAL_STUDENT_MARK';
  static INTERNAL_EXAM_RESULT: string = 'EXAMS_INTERNAL_RESULT';
  static INTERNAL_EXAM_REPORT: string = 'INTERNAL_EXAM_REPORT';
  static INTERNAL_EXAM_RESULT_VIEW: string = 'EXAMS_INTERNAL_RESULT_VIEW';
  static INTERNAL_STUDENT_EVALUATION_EXCEL_DOWNLOAD: string = 'EXAMS_INTERNAL_STUDENT_EVALUATION_EXCEL_DOWNLOAD';
  static INTERNAL_EXAM_UPLOAD: string = 'EXAMS_INTERNAL_RESULT_UPLOAD';

  static INTERNAL_EXAM_HALLS_ASSIGN_STUDENTS: string = 'EXAMS_INTERNAL_EXAM_HALLS_ASSIGN_STUDENTS';
  static INTERNAL_EXAM_SCHEDULER_FETCH_QUESTIONS: string = 'EXAMS_INTERNAL_EXAM_SCHEDULER_FETCH_QUESTIONS';
  static INTERNAL_EXAM_SCHEDULER_DELETE_QUESTIONS: string = 'EXAMS_INTERNAL_EXAM_SCHEDULER_DELETE_QUESTIONS';

  static FINAL: string = 'EXAMS_FINAL';

  static FINAL_EXAM_SESSION: string = 'EXAMS_FINAL_SESSIONS';
  static FINAL_EXAM_SESSION_ADD: string = 'EXAMS_FINAL_SESSIONS_ADD';
  static FINAL_EXAM_SESSION_ASSOCIATE: string = 'EXAMS_FINAL_SESSIONS_ASSOCIATE';
  static FINAL_EXAM_SESSION_UPDATE: string = 'EXAMS_FINAL_SESSIONS_UPDATE';
  static FINAL_EXAM_SESSION_STATUS: string = 'EXAMS_FINAL_SESSIONS_STATUS';
  static FINAL_EXAM_SESSION_DELETE: string = 'EXAMS_FINAL_SESSIONS_DELETE';

  static FINAL_EXAM_QUESTIONS: string = 'EXAMS_FINAL_QUESTIONS';
  static FINAL_EXAM_QUESTION_SECTIONS: string = 'EXAMS_FINAL_EXAM_QUESTION_SECTIONS';
  static FINAL_EXAM_QUESTION_SECTION_ADD: string = 'EXAMS_FINAL_EXAM_QUESTION_SECTION_ADD';
  static FINAL_EXAM_QUESTION_SECTION_UPDATE: string = 'EXAMS_FINAL_EXAM_QUESTION_SECTION_UPDATE';
  static FINAL_EXAM_QUESTION_SECTION_STATUS: string = 'EXAMS_FINAL_EXAM_QUESTION_SECTION_STATUS';
  static FINAL_EXAM_QUESTION_SECTION_DELETE: string = 'EXAMS_FINAL_EXAM_QUESTION_SECTION_DELETE';
  static FINAL_EXAM_QUESTIONS_UPLOAD: string = 'EXAMS_FINAL_QUESTIONS_UPLOAD';
  static FINAL_EXAM_QUESTIONS_DELETE: string = 'EXAMS_FINAL_QUESTIONS_DELETE';

  static FINAL_EXAM_SCHEDULER: string = 'EXAMS_FINAL_SCHEDULER';
  static FINAL_EXAM_SCHEDULER_FINALIZE_QUESTION: string = 'EXAMS_FINAL_SCHEDULER_FINALIZE_QUESTION';
  static FINAL_EXAM_SCHEDULER_FETCH_STUDENT: string = 'EXAMS_FINAL_SCHEDULER_FETCH_STUDENT';
  static FINAL_EXAM_SCHEDULER_MANAGE_SCHEDULE: string = 'EXAMS_FINAL_SCHEDULER_MANAGE_SCHEDULE';
  static FINAL_EXAM_SCHEDULER_MANAGE_EVALUATION: string = 'EXAMS_FINAL_SCHEDULER_MANAGE_EVALUATION';
  static FINAL_EXAM_SCHEDULER_MANAGE_HALL: string = 'EXAMS_FINAL_SCHEDULER_MANAGE_HALL';
  static FINAL_EXAM_SCHEDULER_ELIGIBLE_STUDENT: string = 'EXAMS_FINAL_SCHEDULER_ELIGIBLE_STUDENT';
  static FINAL_EXAM_SCHEDULER_DELETE_QUESTIONS = 'EXAMS_FINAL_EXAM_SCHEDULER_DELETE_QUESTIONS';

  static FINAL_EXAM_DEBARRED_STUDENTS: string = 'EXAM_FINAL_DEBARRED_STUDENTS';
  static FINAL_STUDENT_EVALUATION_EXCEL_DOWNLOAD: string = 'EXAMS_FINAL_STUDENT_EVALUATION_EXCEL_DOWNLOAD';
  static FINAL_EXAM_MARK_DEBARRED: string = 'FINAL_EXAM_MARK_DEBARRED';
  static FINAL_EXAM_REPORT: string = 'FINAL_EXAM_REPORT';

  static CONSOLIDATION: string = 'EXAMS_CONSOLIDATION';
  static CONSOLIDATION_SESSION: string = 'EXAMS_FINAL_CONSOLIDATION_SESSION';
  static CONSOLIDATION_EXAM_SESSION_ASSOCIATE: string = 'EXAMS_CONSOLIDATION_SESSIONS_ASSOCIATE';
  static CONSOLIDATION_EXAM_EVALUATION: string = 'CONSOLIDATION_EXAM_EVALUATION';
  static CONSOLIDATION_EXAM_EVALUATION_STUDENT_MARKS: string = 'CONSOLIDATION_EXAM_EVALUATION_STUDENT_MARKS';
  static CONSOLIDATION_STUDENT_RESULT_EXCEL_DOWNLOAD = 'EXAMS_CONSOLIDATION_STUDENT_RESULT_EXCEL_DOWNLOAD';

  static FINAL_EXAM_ELIGIBLE_STUDENTS: string = 'EXAMS_FINAL_ELIGIBLE_STUDENTS';
  static FINAL_EXAM_ELIGIBLE_ASSIGN: string = 'EXAMS_FINAL_ELIGIBLE_STUDENTS_ASSIGN';

  static FINAL_EXAM_EVALUATOR_SUBJECT: string = 'FINAL_EXAM_EVALUATOR_SUBJECT';
  static FINAL_EXAM_EVALUATOR_CHARGE: string = 'FINAL_EXAM_EVALUATOR_CHARGE';
  static FINAL_EXAM_EVALUATOR_SCHEDULE_EXAM: string = 'FINAL_EXAM_EVALUATOR_SCHEDULE_EXAM';

  static FINAL_EXAM_SCHEDULER_ADD: string = 'EXAMS_FINAL_SCHEDULER_ADD';
  static FINAL_EXAM_SCHEDULER_FETCH: string = 'EXAMS_FINAL_SCHEDULER_FETCH';
  static FINAL_EXAM_SCHEDULER_UPDATE: string = 'EXAMS_FINAL_SCHEDULER_UPDATE';
  static FINAL_EXAM_SCHEDULER_STATUS: string = 'EXAMS_FINAL_SCHEDULER_STATUS';
  static FINAL_EXAM_SCHEDULER_DELETE: string = 'EXAMS_FINAL_SCHEDULER_DELETE';

  static FINAL_EXAM_HALLS: string = 'EXAMS_FINAL_HALLS';
  static FINAL_EXAM_HALLS_ADD: string = 'EXAMS_FINAL_HALLS_ADD';
  static FINAL_EXAM_HALLS_UPDATE: string = 'EXAMS_FINAL_HALLS_UPDATE';
  static FINAL_EXAM_HALLS_STATUS: string = 'EXAMS_FINAL_HALLS_STATUS';
  static FINAL_EXAM_HALLS_STUDENT: string = 'EXAMS_FINAL_HALLS_STUDENT';
  static FINAL_EXAM_HALLS_INVIGILATOR: string = 'EXAMS_FINAL_HALLS_INVIGILATOR';
  static FINAL_EXAM_HALLS_DELETE: string = 'EXAMS_FINAL_HALLS_DELETE';

  static FINAL_EXAM_MARK: string = 'EXAMS_FINAL_MARK';
  static FINAL_EXAM_RESULT: string = 'EXAMS_FINAL_RESULT';
  static FINAL_EXAM_RESULT_VIEW: string = 'EXAMS_FINAL_RESULT_VIEW';
  static FINAL_EXAM_RESULT_UPLOAD: string = 'EXAMS_FINAL_RESULT_UPLOAD';

  static FINAL_EXAM_EVALUATOR: string = 'FINAL_EXAM_EVALUATOR';
  static FINAL_EXAM_SCHEDULE_BACK_PAPER_STUDENT: string = 'FINAL_INTERNAL_SCHEDULER_BACK_PAPER_STUDENT';

  static FINAL_EXAM_HALLS_ASSIGN_STUDENTS = 'EXAMS_FINAL_EXAM_HALLS_ASSIGN_STUDENTS';
  static FINAL_EXAM_SCHEDULER_FETCH_QUESTIONS = 'EXAMS_FINAL_EXAM_SCHEDULER_FETCH_QUESTIONS';

  static FINAL_EXAM_EVALUATION: string = 'FINAL_EXAM_EVALUATION';
  static FINAL_EXAM_EVALUATION_STUDENT_MARKS: string = 'FINAL_EXAM_EVALUATION_STUDENT_MARKS';

  static RESULTS: string = 'RESULTS';

  static RESULTS_CENTER_STUDENT: string = 'RESULTS_CENTER_STUDENT';
  static RESULTS_CENTER_STUDENT_UPDATE_RESULT: string = 'RESULTS_CENTER_STUDENT_UPDATE_RESULT';
  static RESULTS_CENTER_STUDENT_VERIFIED_RESULT: string = 'RESULTS_CENTER_STUDENT_VERIFIED_RESULT';
  static RESULTS_CENTER_STUDENT_REJECTED_RESULT: string = 'RESULTS_CENTER_STUDENT_REJECTED_RESULT';
  static RESULTS_CENTER_STUDENT_DELETE_RESULT: string = 'RESULTS_CENTER_STUDENT_DELETE_RESULT';
  static RESULTS_CENTER_STUDENT_PRINT_RESULT: string = 'RESULTS_CENTER_STUDENT_PRINT_RESULT';

  static RESULTS_PREVIOUS_RESULT: string = 'RESULTS_PREVIOUS_RESULT';
  static RESULTS_PREVIOUS_RESULT_STUDENT: string = 'RESULTS_PREVIOUS_RESULT_STUDENT';
  static RESULTS_PREVIOUS_RESULT_STUDENT_VIEW_RESULT: string = 'RESULTS_PREVIOUS_RESULT_STUDENT_VIEW_RESULT';
  static RESULTS_PREVIOUS_RESULT_STUDENT_UPDATE_RESULT: string = 'RESULTS_PREVIOUS_RESULT_STUDENT_UPDATE_RESULT';
  static RESULTS_NEW_RESULT: string = 'RESULTS_NEW_RESULT';
  static RESULTS_GENERATE_RESULT: string = 'RESULTS_GENERATE_RESULT';

  static DOCS: String = 'DOCS';
  static DOCS_DOCUMENT: String = 'DOCS_DOCUMENT';

  static DOCS_BONA_FIDE: string = 'DOCS_BONA_FIDE';
  static DOCS_BONA_FIDE_ADD: string = 'DOCS_BONA_FIDE_ADD';
  static DOCS_BONA_FIDE_PAYMENT_VERIFY: string = 'DOCS_BONA_FIDE_PAYMENT_VERIFY';
  static DOCS_BONA_FIDE_VERIFY: string = 'DOCS_BONA_FIDE_VERIFY';

  static DOCS_MIGRATION_CERTIFICATE: string = 'DOCS_MIGRATION_CERTIFICATE';
  static DOCS_MIGRATION_CERTIFICATE_ADD: string = 'DOCS_MIGRATION_CERTIFICATE_ADD';
  static DOCS_MIGRATION_CERTIFICATE_PAYMENT_VERIFY: string = 'DOCS_MIGRATION_CERTIFICATE_PAYMENT_VERIFY';
  static DOCS_MIGRATION_CERTIFICATE_VERIFY: string = 'DOCS_MIGRATION_CERTIFICATE_VERIFY';

  static DOCS_PROVISIONAL_CERTIFICATE: string = 'DOCS_PROVISIONAL_CERTIFICATE';
  static DOCS_PROVISIONAL_CERTIFICATE_ADD: string = 'DOCS_PROVISIONAL_CERTIFICATE_ADD';
  static DOCS_PROVISIONAL_CERTIFICATE_PAYMENT_VERIFY: string = 'DOCS_PROVISIONAL_CERTIFICATE_PAYMENT_VERIFY';
  static DOCS_PROVISIONAL_CERTIFICATE_VERIFY: string = 'DOCS_PROVISIONAL_CERTIFICATE_VERIFY';

  static DOCS_CHARACTER_CERTIFICATE: string = 'DOCS_CHARACTER_CERTIFICATE';
  static DOCS_CHARACTER_CERTIFICATE_ADD: string = 'DOCS_CHARACTER_CERTIFICATE_ADD';
  static DOCS_CHARACTER_CERTIFICATE_PAYMENT_VERIFY: string = 'DOCS_CHARACTER_CERTIFICATE_PAYMENT_VERIFY';
  static DOCS_CHARACTER_CERTIFICATE_VERIFY: string = 'DOCS_CHARACTER_CERTIFICATE_VERIFY';

  static DOCS_DUPLICATE_DMC: string = 'DOCS_DUPLICATE_DMC';
  static DOCS_DUPLICATE_DMC_ADD: string = 'DOCS_DUPLICATE_DMC_ADD';
  static DOCS_DUPLICATE_DMC_PAYMENT_VERIFY: string = 'DOCS_DUPLICATE_DMC_PAYMENT_VERIFY';
  static DOCS_DUPLICATE_DMC_VERIFY: string = 'DOCS_DUPLICATE_DMC_VERIFY';

  static DOCS_DEGREE: string = 'DOCS_DEGREE';
  static DOCS_DEGREE_ADD: string = 'DOCS_DEGREE_ADD';
  static DOCS_DEGREE_PAYMENT_VERIFY: string = 'DOCS_DEGREE_PAYMENT_VERIFY';
  static DOCS_DEGREE_VERIFY: string = 'DOCS_DEGREE_VERIFY';

  static DOCS_MARKSHEET: string = 'DOCS_MARKSHEET';
  static DOCS_MARKSHEET_ADD: string = 'DOCS_MARKSHEET_ADD';
  static DOCS_MARKSHEET_PAYMENT_VERIFY: string = 'DOCS_MARKSHEET_PAYMENT_VERIFY';
  static DOCS_MARKSHEET_VERIFY: string = 'DOCS_MARKSHEET_VERIFY';

  static DOCS_ORIGINAL_DEGREE_DETAIL: string = 'DOCS_ORIGINAL_DEGREE_DETAIL';

  static DOCS_NO_DUE_SLIP_ACADEMIC: string = 'DOCS_NO_DUE_SLIP_ACADEMIC';
  static DOCS_NO_DUE_SLIP_HOSTEL: string = 'DOCS_NO_DUE_SLIP_HOSTEL';
  static DOCS_NO_DUE_SLIP_LIBRARY: string = 'DOCS_NO_DUE_SLIP_LIBRARY';
  static DOCS_NO_DUE_SLIP_ACCOUNT: string = 'DOCS_NO_DUE_SLIP_ACCOUNT';
  static DOCS_NO_DUE_SLIP_REGISTRAR: string = 'DOCS_NO_DUE_SLIP_REGISTRAR';
  static DOCS_NO_DUE_SLIP_OTHER: string = 'DOCS_NO_DUE_SLIP_OTHER';
  static DOCS_NO_DUES_SLIP_GENERATE: string = 'DOCS_NO_DUE_SLIP_GENERATE';
  static DOCS_NO_DUES_SLIP_UPDATE: string = 'DOCS_NO_DUE_SLIP_UPDATE';
  static DOCS_NO_DUES_SLIP_DETAIL: string = 'DOCS_NO_DUE_SLIP_DETAIL';

  static UTILITIES: string = 'UTILITIES';

  static UTILITIES_HOSTEL: string = 'UTILITIES_HOSTELS';
  static UTILITIES_HOSTEL_ACTIVE_STUDENT: string = 'UTILITIES_HOSTELS_ACTIVE_STUDENT';
  static UTILITIES_HOSTEL_ADD: string = 'UTILITIES_HOSTELS_ADD';
  static UTILITIES_HOSTEL_ADD_ROOM: string = 'UTILITIES_HOSTELS_ADD_ROOM';
  static UTILITIES_HOSTEL_UPDATE_ROOM: string = 'UTILITIES_HOSTELS_UPDATE_ROOM';
  static UTILITIES_HOSTEL_STATUS_ROOM: string = 'UTILITIES_HOSTELS_STATUS_ROOM';
  static UTILITIES_HOSTEL_DELETE_ROOM: string = 'UTILITIES_HOSTELS_DELETE_ROOM';
  static UTILITIES_HOSTEL_ROOM_STUDENT: string = 'UTILITIES_HOSTELS_ROOM_STUDENT';
  static UTILITIES_HOSTEL_ROOM_STUDENT_SEARCH: string = 'UTILITIES_HOSTEL_ROOM_STUDENT_SEARCH';
  static UTILITIES_HOSTEL_ROOM_STUDENT_DELETE: string = 'UTILITIES_HOSTELS_ROOM_STUDENT_DELETE';
  static UTILITIES_HOSTEL_ADD_MENU: string = 'UTILITIES_HOSTELS_ADD_MENU';
  static UTILITIES_HOSTEL_UPDATE: string = 'UTILITIES_HOSTELS_UPDATE';
  static UTILITIES_HOSTEL_STATUS: string = 'UTILITIES_HOSTELS_STATUS';
  static UTILITIES_HOSTEL_DELETE: string = 'UTILITIES_HOSTELS_DELETE';

  static UTILITIES_VEHICLE: string = 'UTILITIES_VEHICLES';
  static UTILITIES_VEHICLE_DRIVER: string = 'UTILITIES_VEHICLES_DRIVER';
  static UTILITIES_VEHICLE_DRIVER_ADD: string = 'UTILITIES_VEHICLES_DRIVER_ADD';
  static UTILITIES_VEHICLE_DRIVER_UPDATE: string = 'UTILITIES_VEHICLES_DRIVER_UPDATE';
  static UTILITIES_VEHICLE_DRIVER_STATUS: string = 'UTILITIES_VEHICLES_DRIVER_STATUS';
  static UTILITIES_VEHICLE_DRIVER_DELETE: string = 'UTILITIES_VEHICLES_DRIVER_DELETE';
  static UTILITIES_VEHICLE_ACTIVE_STUDENT: string = 'UTILITIES_VEHICLES_ACTIVE_STUDENT';
  static UTILITIES_VEHICLE_ADD: string = 'UTILITIES_VEHICLES_ADD';
  static UTILITIES_VEHICLE_STUDENT: string = 'UTILITIES_VEHICLE_STUDENT';
  static UTILITIES_VEHICLE_STUDENT_SEARCH: string = 'UTILITIES_VEHICLE_STUDENT_SEARCH';
  static UTILITIES_VEHICLE_ADD_VEHICLE: string = 'UTILITIES_VEHICLES_ADD_VEHICLE';
  static UTILITIES_VEHICLE_ADD_ROUTE: string = 'UTILITIES_VEHICLES_ADD_ROUTE';
  static UTILITIES_VEHICLE_UPDATE: string = 'UTILITIES_VEHICLES_UPDATE';
  static UTILITIES_VEHICLE_STATUS: string = 'UTILITIES_VEHICLES_STATUS';
  static UTILITIES_VEHICLE_DELETE: string = 'UTILITIES_VEHICLES_DELETE';

  static UTILITIES_HOLIDAY: string = 'UTILITIES_HOLIDAYS';
  static UTILITIES_HOLIDAY_ADD: string = 'UTILITIES_HOLIDAYS_ADD';
  static UTILITIES_HOLIDAY_UPDATE: string = 'UTILITIES_HOLIDAYS_UPDATE';
  static UTILITIES_HOLIDAY_DELETE: string = 'UTILITIES_HOLIDAYS_DELETE';

  static UTILITIES_MISCELLANEOUS: string = 'UTILITIES_MISCELLANEOUS';
  static UTILITIES_MISCELLANEOUS_ADD: string = 'UTILITIES_MISCELLANEOUS_ADD';
  static UTILITIES_MISCELLANEOUS_UPDATE: string = 'UTILITIES_MISCELLANEOUS_UPDATE';
  static UTILITIES_MISCELLANEOUS_STATUS: string = 'UTILITIES_MISCELLANEOUS_STATUS';
  static UTILITIES_MISCELLANEOUS_DELETE: string = 'UTILITIES_MISCELLANEOUS_DELETE';

  static UTILITIES_SCHOLARSHIP: string = 'UTILITIES_SCHOLARSHIP';
  static UTILITIES_SCHOLARSHIP_ADD: string = 'UTILITIES_SCHOLARSHIP_ADD';
  static UTILITIES_SCHOLARSHIP_VIEW: string = 'UTILITIES_SCHOLARSHIP_VIEW';
  static UTILITIES_SCHOLARSHIP_UPDATE: string = 'UTILITIES_SCHOLARSHIP_UPDATE';
  static UTILITIES_SCHOLARSHIP_STATUS: string = 'UTILITIES_SCHOLARSHIP_STATUS';
  static UTILITIES_SCHOLARSHIP_DELETE: string = 'UTILITIES_SCHOLARSHIP_DELETE';

  static UTILITIES_REPORT: string = 'UTILITIES_REPORTS';

  static ALUMNI: string = 'ALUMNI';

  static ALUMNI_LIST: string = 'ALUMNI_LIST';
  static ALUMNI_LIST_ADD: string = 'ALUMNI_LIST_ADD';
  static ALUMNI_LIST_ACTIVITY: string = 'ALUMNI_LIST_ACTIVITY';
  static ALUMNI_LIST_UPDATE: string = 'ALUMNI_LIST_UPDATE';
  static ALUMNI_LIST_STATUS: string = 'ALUMNI_LIST_STATUS';
  static ALUMNI_LIST_DELETE: string = 'ALUMNI_LIST_DELETE';

  static ENTRANCE_EXAM: string = 'ENTRANCE_EXAM';
  static ENTRANCE_EXAM_STUDENT: string = 'ENTRANCE_EXAM_STUDENT';
  static ENTRANCE_EXAM_QUESTION: string = 'ENTRANCE_EXAM_QUESTION';
  static ENTRANCE_EXAM_RESULT: string = 'ENTRANCE_EXAM_RESULT';
  static ENTRANCE_EXAM_QUESTION_SECTION: string = 'ENTRANCE_EXAM_QUESTION_SECTION';

  static SUPPORT_TICKET: string = 'SUPPORT_TICKETS';

  static STUDENT_SUPPORT_TICKET: string = 'SUPPORTS_TICKETS_STUDENT';
  static STUDENT_SUPPORT_TICKET_ACADEMIC: string = 'SUPPORTS_TICKETS_STUDENT_ACADEMIC';
  static STUDENT_SUPPORT_TICKET_ACCOUNT: string = 'SUPPORTS_TICKETS_STUDENT_ACCOUNT';
  static STUDENT_SUPPORT_TICKET_EXAMINATION: string = 'SUPPORTS_TICKETS_STUDENT_EXAMINATION';
  static STUDENT_SUPPORT_TICKET_ADMISSION: string = 'SUPPORTS_TICKETS_STUDENT_ADMISSION';
  static STUDENT_SUPPORT_TICKET_HOSTEL: string = 'SUPPORTS_TICKETS_STUDENT_HOSTEL';
  static STUDENT_SUPPORT_TICKET_OTHER: string = 'SUPPORTS_TICKETS_STUDENT_OTHER';

  static EMPLOYEE_SUPPORT_TICKET_TYPE: string = 'SUPPORTS_TICKETS_TYPE_EMPLOYEE';
  static EMPLOYEE_SUPPORT_TICKET: string = 'SUPPORTS_TICKETS_EMPLOYEE';
  static EMPLOYEE_SUPPORT_TICKET_ADD: string = 'SUPPORTS_TICKETS_EMPLOYEE_ADD';
  static EMPLOYEE_SUPPORT_TICKET_ACADEMIC: string = 'SUPPORTS_TICKETS_EMPLOYEE_ACADEMIC';
  static EMPLOYEE_SUPPORT_TICKET_IT_SERVICE: string = 'SUPPORTS_TICKETS_EMPLOYEE_IT_SERVICE';
  static EMPLOYEE_SUPPORT_TICKET_HR_ISSUE: string = 'SUPPORTS_TICKETS_EMPLOYEE_HR_ISSUE';
  static EMPLOYEE_SUPPORT_TICKET_VEHICLE: string = 'SUPPORTS_TICKETS_EMPLOYEE_VEHICLE';
  static EMPLOYEE_SUPPORT_TICKET_ACCOUNT: string = 'SUPPORTS_TICKETS_EMPLOYEE_ACCOUNT';
  static EMPLOYEE_SUPPORT_TICKET_ADMINISTRATION: string = 'SUPPORTS_TICKETS_EMPLOYEE_ADMINISTRATION';
  static EMPLOYEE_SUPPORT_TICKET_OTHER: string = 'SUPPORTS_TICKETS_EMPLOYEE_OTHER';

  static CENTER_SUPPORT_TICKET: string = 'SUPPORTS_TICKETS_CENTER_TICKETS';
  static CENTER_REMARK: string = 'SUPPORTS_TICKETS_CENTER_TICKETS_REMARK';
  static CENTER_SUPPORT_TICKET_DELETE: string = 'SUPPORTS_TICKETS_CENTER_TICKETS_DELETE';
  static CENTER_UPLOAD: string = 'SUPPORTS_TICKETS_CENTER_TICKETS_UPLOAD';
  static CENTER_VIEW: string = 'SUPPORTS_TICKETS_CENTER_TICKETS_VIEW';

  static SUPPORT_TICKET_REPORT: string = 'SUPPORTS_TICKETS_REPORTS';

  static ALLEGATIONS: string = 'ALLEGATIONS';
  static ADD_ALLEGATIONS: string = 'ALLEGATIONS_ADD';
  static LIST_ALLEGATIONS: string = 'ALLEGATIONS_LIST';
  static UPDATE_ALLEGATIONS: string = 'ALLEGATIONS_LIST_UPDATE';
  static DELETE_ALLEGATIONS: string = 'ALLEGATIONS_LIST_DELETE';
  static ALLEGATION_DETAILS: string = 'ALLEGATIONS_LIST_DETAIL';
  static ALLEGATION_TRANSACTIONS: string = 'ALLEGATIONS_TRANSACTIONS';
  static ALLEGATION_TRANSACTIONS_STATUS: string = 'ALLEGATIONS_TRANSACTIONS_STATUS';

  static TASKS: string = 'TASKS';
  static TASKS_LIST: string = 'TASKS_LIST';
  static TASKS_LIST_ADD: string = 'TASKS_LIST_ADD';
  static TASKS_LIST_ADD_SUB_TASK: string = 'TASKS_LIST_ADD_SUB_TASK';
  static TASKS_LIST_ASSIGN: string = 'TASKS_LIST_ASSIGN';
  static TASKS_LIST_STATUS: string = 'TASKS_LIST_STATUS';
  static TASKS_LIST_UPLOAD_DOCUMENT: string = 'TASKS_LIST_UPLOAD_DOCUMENT';
  static TASKS_LIST_UPDATE: string = 'TASKS_LIST_UPDATE';
  static TASKS_LIST_DELETE: string = 'TASKS_LIST_DELETE';
  static TASKS_LIST_DETAIL: string = 'TASKS_LIST_DETAIL';

  static NOTIFICATION: string = 'NOTIFICATIONS';

  static STUDENT_NOTIFICATION: string = 'NOTIFICATIONS_STUDENT_NOTIFICATION';
  static STUDENT_NOTIFICATION_ADD: string = 'NOTIFICATIONS_STUDENT_ADD';
  static STUDENT_NOTIFICATION_DELETE: string = 'NOTIFICATIONS_STUDENT_DELETE';

  static CENTER_NOTIFICATION: string = 'NOTIFICATIONS_CENTER_NOTIFICATION';
  static CENTER_NOTIFICATION_ADD: string = 'NOTIFICATIONS_CENTER_NOTIFICATION_ADD';
  static CENTER_NOTIFICATION_DELETE: string = 'NOTIFICATIONS_CENTER_NOTIFICATION_DELETE';

  static NOTIFICATION_REPORT: string = 'NOTIFICATIONS_REPORTS';

  static WEBSITE_LANDING: string = 'WEBSITE_LANDING';

  static WEBSITE_LANDING_BANNER: string = 'WEBSITE_LANDING_BANNER';

  static WEBSITE_LANDING_BANNER_TOP: string = 'WEBSITE_LANDING_BANNER_TOP';
  static WEBSITE_LANDING_BANNER_TOP_ADD: string = 'WEBSITE_LANDING_BANNER_TOP_ADD';
  static WEBSITE_LANDING_BANNER_TOP_MEDIUM_SCREEN: string = 'WEBSITE_LANDING_BANNER_TOP_MEDIUM_SCREEN';
  static WEBSITE_LANDING_BANNER_TOP_MOBILE_SCREEN: string = 'WEBSITE_LANDING_BANNER_TOP_MOBILE_SCREEN';
  static WEBSITE_LANDING_BANNER_TOP_UPDATE: string = 'WEBSITE_LANDING_BANNER_TOP_UPDATE';
  static WEBSITE_LANDING_BANNER_TOP_STATUS: string = 'WEBSITE_LANDING_BANNER_TOP_STATUS';
  static WEBSITE_LANDING_BANNER_TOP_DELETE: string = 'WEBSITE_LANDING_BANNER_TOP_DELETE';

  static WEBSITE_LANDING_BANNER_MIDDLE: string = 'WEBSITE_LANDING_BANNER_MIDDLE';
  static WEBSITE_LANDING_BANNER_MIDDLE_ADD: string = 'WEBSITE_LANDING_BANNER_MIDDLE_ADD';
  static WEBSITE_LANDING_BANNER_MIDDLE_UPDATE: string = 'WEBSITE_LANDING_BANNER_MIDDLE_UPDATE';
  static WEBSITE_LANDING_BANNER_MIDDLE_STATUS: string = 'WEBSITE_LANDING_BANNER_MIDDLE_STATUS';
  static WEBSITE_LANDING_BANNER_MIDDLE_DELETE: string = 'WEBSITE_LANDING_BANNER_MIDDLE_DELETE';

  static WEBSITE_LANDING_BANNER_PROMOTION: string = 'WEBSITE_LANDING_BANNER_PROMOTION';
  static WEBSITE_LANDING_BANNER_PROMOTION_ADD: string = 'WEBSITE_LANDING_BANNER_PROMOTION_ADD';
  static WEBSITE_LANDING_BANNER_PROMOTION_UPDATE: string = 'WEBSITE_LANDING_BANNER_PROMOTION_UPDATE';
  static WEBSITE_LANDING_BANNER_PROMOTION_STATUS: string = 'WEBSITE_LANDING_BANNER_PROMOTION_STATUS';
  static WEBSITE_LANDING_BANNER_PROMOTION_DELETE: string = 'WEBSITE_LANDING_BANNER_PROMOTION_DELETE';

  static WEBSITE_LANDING_NEWS_HIGHLIGHT: string = 'WEBSITE_LANDING_NEWS_&_HIGHLIGHT';

  static WEBSITE_LANDING_NEWS_HIGHLIGHT_AWARD_ACHIEVEMENT: string = 'WEBSITE_LANDING_NEWS_&_HIGHLIGHT_AWARD_&_ACHIEVEMENT';
  static WEBSITE_LANDING_NEWS_HIGHLIGHT_AWARD_ACHIEVEMENT_ADD: string = 'WEBSITE_LANDING_NEWS_&_HIGHLIGHT_AWARD_&_ACHIEVEMENT_ADD';
  static WEBSITE_LANDING_NEWS_HIGHLIGHT_AWARD_ACHIEVEMENT_ADD_IMAGE: string = 'WEBSITE_LANDING_NEWS_&_HIGHLIGHT_AWARD_&_ACHIEVEMENT_ADD_IMAGE';
  static WEBSITE_LANDING_NEWS_HIGHLIGHT_AWARD_ACHIEVEMENT_UPDATE: string = 'WEBSITE_LANDING_NEWS_&_HIGHLIGHT_AWARD_&_ACHIEVEMENT_UPDATE';
  static WEBSITE_LANDING_NEWS_HIGHLIGHT_AWARD_ACHIEVEMENT_STATUS: string = 'WEBSITE_LANDING_NEWS_&_HIGHLIGHT_AWARD_&_ACHIEVEMENT_STATUS';
  static WEBSITE_LANDING_NEWS_HIGHLIGHT_AWARD_ACHIEVEMENT_DELETE: string = 'WEBSITE_LANDING_NEWS_&_HIGHLIGHT_AWARD_&_ACHIEVEMENT_DELETE';

  static WEBSITE_LANDING_NEWS_HIGHLIGHT_EVENT: string = 'WEBSITE_LANDING_NEWS_&_HIGHLIGHT_EVENT';
  static WEBSITE_LANDING_NEWS_HIGHLIGHT_EVENT_ADD: string = 'WEBSITE_LANDING_NEWS_&_HIGHLIGHT_EVENT_ADD';
  static WEBSITE_LANDING_NEWS_HIGHLIGHT_EVENT_ADD_IMAGE: string = 'WEBSITE_LANDING_NEWS_&_HIGHLIGHT_EVENT_ADD_IMAGE';
  static WEBSITE_LANDING_NEWS_HIGHLIGHT_EVENT_DELETE_IMAGE: string = 'WEBSITE_LANDING_NEWS_&_HIGHLIGHT_EVENT_DELETE_IMAGE';
  static WEBSITE_LANDING_NEWS_HIGHLIGHT_EVENT_UPDATE: string = 'WEBSITE_LANDING_NEWS_&_HIGHLIGHT_EVENT_UPDATE';
  static WEBSITE_LANDING_NEWS_HIGHLIGHT_EVENT_STATUS: string = 'WEBSITE_LANDING_NEWS_&_HIGHLIGHT_EVENT_STATUS';
  static WEBSITE_LANDING_NEWS_HIGHLIGHT_EVENT_DELETE: string = 'WEBSITE_LANDING_NEWS_&_HIGHLIGHT_EVENT_DELETE';

  static WEBSITE_LANDING_NEWS_HIGHLIGHT_ANNOUNCEMENT: string = 'WEBSITE_LANDING_NEWS_&_HIGHLIGHT_ANNOUNCEMENT';
  static WEBSITE_LANDING_NEWS_HIGHLIGHT_ANNOUNCEMENT_ADD: string = 'WEBSITE_LANDING_NEWS_&_HIGHLIGHT_ANNOUNCEMENT_ADD';
  static WEBSITE_LANDING_NEWS_HIGHLIGHT_ANNOUNCEMENT_ADD_IMAGE: string = 'WEBSITE_LANDING_NEWS_&_HIGHLIGHT_ANNOUNCEMENT_ADD_IMAGE';
  static WEBSITE_LANDING_NEWS_HIGHLIGHT_ANNOUNCEMENT_ADD_THUMBNAIL: string = 'WEBSITE_LANDING_NEWS_&_HIGHLIGHT_ANNOUNCEMENT_ADD_THUMBNAIL';
  static WEBSITE_LANDING_NEWS_HIGHLIGHT_ANNOUNCEMENT_UPDATE: string = 'WEBSITE_LANDING_NEWS_&_HIGHLIGHT_ANNOUNCEMENT_UPDATE';
  static WEBSITE_LANDING_NEWS_HIGHLIGHT_ANNOUNCEMENT_STATUS: string = 'WEBSITE_LANDING_NEWS_&_HIGHLIGHT_ANNOUNCEMENT_STATUS';
  static WEBSITE_LANDING_NEWS_HIGHLIGHT_ANNOUNCEMENT_DELETE: string = 'WEBSITE_LANDING_NEWS_&_HIGHLIGHT_ANNOUNCEMENT_DELETE';

  static WEBSITE_LANDING_GALLERY: string = 'WEBSITE_LANDING_GALLERY';

  static WEBSITE_LANDING_GALLERY_IMAGE_VIDEO: string = 'WEBSITE_LANDING_GALLERY_IMAGE_VIDEO';
  static WEBSITE_LANDING_GALLERY_IMAGE_VIDEO_ADD: string = 'WEBSITE_LANDING_GALLERY_IMAGE_VIDEO_ADD';
  static WEBSITE_LANDING_GALLERY_IMAGE_VIDEO_ADD_IMAGE: string = 'WEBSITE_LANDING_GALLERY_IMAGE_VIDEO_ADD_IMAGE';
  static WEBSITE_LANDING_GALLERY_IMAGE_VIDEO_ADD_VIDEO: string = 'WEBSITE_LANDING_GALLERY_IMAGE_VIDEO_ADD_VIDEO';
  static WEBSITE_LANDING_GALLERY_IMAGE_VIDEO_DELETE_IMAGE: string = 'WEBSITE_LANDING_GALLERY_IMAGE_VIDEO_DELETE_IMAGE';
  static WEBSITE_LANDING_GALLERY_IMAGE_VIDEO_DELETE_VIDEO: string = 'WEBSITE_LANDING_GALLERY_IMAGE_VIDEO_DELETE_VIDEO';
  static WEBSITE_LANDING_GALLERY_IMAGE_VIDEO_UPDATE: string = 'WEBSITE_LANDING_GALLERY_IMAGE_VIDEO_UPDATE';
  static WEBSITE_LANDING_GALLERY_IMAGE_VIDEO_STATUS: string = 'WEBSITE_LANDING_GALLERY_IMAGE_VIDEO_STATUS';
  static WEBSITE_LANDING_GALLERY_IMAGE_VIDEO_DELETE: string = 'WEBSITE_LANDING_GALLERY_IMAGE_VIDEO_DELETE';

  static WEBSITE_LANDING_FACULTIES: string = 'WEBSITE_LANDING_FACULTIES';

  static WEBSITE_LANDING_FACULTIES_FACULTY: string = 'WEBSITE_LANDING_FACULTIES_FACULTY';
  static WEBSITE_LANDING_FACULTIES_FACULTY_ADD: string = 'WEBSITE_LANDING_FACULTIES_FACULTY_ADD';
  static WEBSITE_LANDING_FACULTIES_FACULTY_UPDATE: string = 'WEBSITE_LANDING_FACULTIES_FACULTY_UPDATE';
  static WEBSITE_LANDING_FACULTIES_FACULTY_STATUS: string = 'WEBSITE_LANDING_FACULTIES_FACULTY_STATUS';
  static WEBSITE_LANDING_FACULTIES_FACULTY_DELETE: string = 'WEBSITE_LANDING_FACULTIES_FACULTY_DELETE';

  static WEBSITE_LANDING_STUDENT_VOICES: string = 'WEBSITE_LANDING_STUDENT_VOICES';

  static WEBSITE_LANDING_STUDENT_VOICES_TESTIMONIAL: string = 'WEBSITE_LANDING_STUDENT_VOICES_TESTIMONIAL';
  static WEBSITE_LANDING_STUDENT_VOICES_TESTIMONIAL_ADD: string = 'WEBSITE_LANDING_STUDENT_VOICES_TESTIMONIAL_ADD';
  static WEBSITE_LANDING_STUDENT_VOICES_TESTIMONIAL_ADD_IMAGE: string = 'WEBSITE_LANDING_STUDENT_VOICES_TESTIMONIAL_ADD_IMAGE';
  static WEBSITE_LANDING_STUDENT_VOICES_TESTIMONIAL_UPDATE: string = 'WEBSITE_LANDING_STUDENT_VOICES_TESTIMONIAL_UPDATE';
  static WEBSITE_LANDING_STUDENT_VOICES_TESTIMONIAL_STATUS: string = 'WEBSITE_LANDING_STUDENT_VOICES_TESTIMONIAL_STATUS';
  static WEBSITE_LANDING_STUDENT_VOICES_TESTIMONIAL_DELETE: string = 'WEBSITE_LANDING_STUDENT_VOICES_TESTIMONIAL_DELETE';

  static WEBSITE_LANDING_STUDENT_VOICES_SUCCESS_STORIES: string = 'WEBSITE_LANDING_STUDENT_VOICES_SUCCESS_STORIES';
  static WEBSITE_LANDING_STUDENT_VOICES_SUCCESS_STORIES_ADD: string = 'WEBSITE_LANDING_STUDENT_VOICES_SUCCESS_STORIES_ADD';
  static WEBSITE_LANDING_STUDENT_VOICES_SUCCESS_STORIES_ADD_IMAGE: string = 'WEBSITE_LANDING_STUDENT_VOICES_SUCCESS_STORIES_ADD_IMAGE';
  static WEBSITE_LANDING_STUDENT_VOICES_SUCCESS_STORIES_ADD_VIDEO: string = 'WEBSITE_LANDING_STUDENT_VOICES_SUCCESS_STORIES_ADD_VIDEO';
  static WEBSITE_LANDING_STUDENT_VOICES_SUCCESS_STORIES_UPDATE: string = 'WEBSITE_LANDING_STUDENT_VOICES_SUCCESS_STORIES_UPDATE';
  static WEBSITE_LANDING_STUDENT_VOICES_SUCCESS_STORIES_STATUS: string = 'WEBSITE_LANDING_STUDENT_VOICES_SUCCESS_STORIES_STATUS';
  static WEBSITE_LANDING_STUDENT_VOICES_SUCCESS_STORIES_DELETE: string = 'WEBSITE_LANDING_STUDENT_VOICES_SUCCESS_STORIES_DELETE';

  static PREVIOUS_CLASSES: string = 'PREVIOUS_CLASSES';
  static UPCOMING_CLASSES: string = 'UPCOMING_CLASSES';
  static ASSIGNMENTS: string = 'ASSIGNMENTS';
  static ASSIGNMENTS_ADD: string = 'ASSIGNMENTS_ADD';
  static ASSIGNMENTS_UPLOAD_MARKS: string = 'ASSIGNMENTS_UPLOAD_MARKS';
  static REPORT_CLASSES: string = 'REPORT_CLASSES';

  static PHD_ENTRANCE_STUDENT: string = 'PHD_ENTRANCE_STUDENT';

  static MEMBER: string = 'MEMBER';
  static MEMBER_ADD: string = 'MEMBER_ADD';
  static MEMBER_UPDATE: string = 'MEMBER_UPDATE';
  static MEMBER_LIST: string = 'MEMBER_LIST';
  static MEMBER_PASSWORD: string = 'MEMBER_PASSWORD';
  static MEMBER_PROFILE_IMAGE: string = 'MEMBER_PROFILE_IMAGE';
  static MEMBER_STATUS: string = 'MEMBER_STATUS';
  static MEMBER_DELETE: string = 'MEMBER_DELETE';
}
